import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import type React from 'react';
import DossierCardWrapper from '#build-flags/routes/dossiers/wrapper/DossierCardWrapper.tsx';

export interface ContentCardWrapperProps {
  submission?: RichiestaDTO | null;
  children?: React.ReactNode;
}

/**
 * Wrapper
 */
export function ContentCardWrapper(props: ContentCardWrapperProps) {
  const { submission, children } = props;

  return process.env.BUILD_FLAGS_DOSSIERS &&
    submission?.idIstanzaProcedimentoPratica ? (
    <DossierCardWrapper submission={submission}>{children}</DossierCardWrapper>
  ) : (
    <>{children}</>
  );
}
